import React from 'react'
//import PropTypes from 'prop-types'
//import './style.css'

const PoweredBy = (props) => {
    return (
        <img src={require('./powered.png')} {...props} className={'powered-by'} />
    )
}

PoweredBy.propTypes = {}

PoweredBy.defaultProps = {}

export default PoweredBy



// WEBPACK FOOTER //
// ./src/components/_minha-central/PoweredBy/index.js